import { Tab, Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const CustomTab = withStyles((theme: Theme) => ({
    root: {
        color: theme.palette.grey[700],
        fontSize: theme.typography.pxToRem(13),
    },
}))(Tab);
